import withRoot from './providers';
import App from './components/App';

export default withRoot(App);
